import { router } from '@inertiajs/react'
import { useEffect, useState } from 'react'

function FlashAlert({ variant, message, onDismiss, textDark }) {
  if (!message) return null

  const className = [
    'alert',
    `alert-${variant}`,
    textDark ? 'text-dark' : '',
    'alert-dismissible',
    'fade',
    'show',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={className} role="alert">
      <h4 className="alert-heading mb-0">{message}</h4>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        onClick={onDismiss}
      ></button>
    </div>
  )
}

function ApproverList({ approvers }) {
  if (!approvers || approvers.length === 0) {
    return <span className="text-muted">—</span>
  }

  return (
    <div className="avatar-group d-inline-flex align-items-center">
      {approvers.map((approval, index) => (
        <span
          key={index}
          className="avatar avatar-xs"
          aria-label={approval.user?.full_name || approval.user?.email}
          data-bs-toggle="tooltip"
          data-bs-title={approval.user?.full_name || approval.user?.email}
        >
          <img
            src={approval.user?.avatar_url}
            className="avatar-img rounded-circle"
            alt={approval.user?.full_name || approval.user?.email}
          />
        </span>
      ))}
    </div>
  )
}

export default function Index({ bonuses, notice, alert }) {
  const [flashNotice, setFlashNotice] = useState(notice)
  const [flashAlert, setFlashAlert] = useState(alert)

  useEffect(() => {
    if (notice) setFlashNotice(notice)
    if (alert) setFlashAlert(alert)
  }, [notice, alert])

  return (
    <div className="container-fluid">
      <div className="header">
        <div className="header-body">
          <div className="row align-items-end">
            <div className="col">
              <h6 className="header-pretitle">Executives</h6>
              <h1 className="header-title">Bonuses</h1>
            </div>
            <div className="col-auto">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => router.visit('/executives/bonuses/new')}
              >
                Create Bonus
              </button>
            </div>
          </div>
        </div>
      </div>

      <FlashAlert variant="danger" message={flashAlert} onDismiss={() => setFlashAlert(null)} />
      <FlashAlert variant="success" message={flashNotice} textDark onDismiss={() => setFlashNotice(null)} />

      <div className="card">
        <div className="card-header">
          <h4 className="card-header-title">Previous Bonuses</h4>
        </div>
        <div className="table-responsive">
          <table className="table table-sm table-hover table-nowrap card-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Date Finalized</th>
                <th>Approvers</th>
              </tr>
            </thead>
            <tbody>
              {(bonuses || []).map((bonus) => (
                <tr key={bonus.id}>
                  <td>
                    <a
                      href={`/executives/bonuses/${bonus.id}`}
                      className="fw-semibold"
                      onClick={(e) => {
                        e.preventDefault()
                        router.visit(`/executives/bonuses/${bonus.id}`)
                      }}
                    >
                      {bonus.name}
                    </a>
                  </td>
                  <td>
                    <span className={`badge bg-${bonus.status === 'finalized' ? 'success' : 'secondary'}`}>
                      {bonus.status}
                    </span>
                  </td>
                  <td>{bonus.finalized_at_label || '—'}</td>
                  <td>
                    <ApproverList approvers={bonus.approvers} />
                  </td>
                </tr>
              ))}

              {!bonuses?.length ? (
                <tr>
                  <td colSpan={4} className="text-center text-body-secondary py-4">
                    No bonuses found.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
